interface GeneralContact {
  email: string;
  phone: string;
}

const encodeContactInfo = (value: string): string => {
  try {
    return btoa(unescape(encodeURIComponent(value)));
  } catch {
    return value;
  }
};

export const decodeContactInfo = (encoded: string): string => {
  try {
    return decodeURIComponent(escape(atob(encoded)));
  } catch {
    return "";
  }
};

export const generalContact: GeneralContact = {
  email: encodeContactInfo("hey@enno-und-jens.de"),
  phone: encodeContactInfo("+4939432636832"),
};
